import api, { callRefreshToken } from "../config/http-common";

export const getProjectMember = async (id) => {
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().get("/project_member/" + id);
};
